import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getPowerBIMaterialDetailsData = createApi(`PowerBIMaterialDetailsSlice`,"GET");

const PowerBIMaterialDetailsSlice = createSlice({
  name: 'PowerBIMaterialDetailsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPowerBIMaterialDetailsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPowerBIMaterialDetailsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPowerBIMaterialDetailsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PowerBIMaterialDetailsSlice.reducer;